import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const DrivingRange = ({ drivingRange }: SpecProps<"driving_range">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (drivingRange == null || drivingRange === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.driving_range",
    message: "Driving range",
    comment: "Field for 'driving range' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.common.distance.kilometer.postfix",
    message: "{distance} km",
    comment: "Distance incl. postfix",
    values: { distance: formatNumber(drivingRange, locale) },
  });

  const tooltip = i18n.t({
    id: "itemPageLayout.keyInfo.tooltip.wltp",
    message:
      "WLTP is a metric from when the car was new and the actual range must be seen in context of age, km, driving pattern and weather conditions",
    comment: "Tooltip for 'driving range' in ad specification",
  });

  return <FieldValuePair field={field} value={value} tooltip={tooltip} />;
};
